if (!customElements.get('clan-airy-hero')) {
  class ClanAiryHero extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('[data-airy-slide]')];
      this.dots = [...this.querySelectorAll('[data-airy-dot]')];
      this.index = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
      this.delay = Number(this.dataset.delay || 6) * 1000;
      this.autoplay = this.dataset.autoplay === 'true' && !matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.show(index, true)));
      this.querySelector('[data-airy-prev]')?.addEventListener('click', () => this.show(this.index - 1, true));
      this.querySelector('[data-airy-next]')?.addEventListener('click', () => this.show(this.index + 1, true));
      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => this.start());
      this.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'mouse') return;
        this.pointerStart = event.clientX;
      }, { passive: true });
      this.addEventListener('pointerup', (event) => {
        if (this.pointerStart == null || event.pointerType === 'mouse') return;
        const distance = event.clientX - this.pointerStart;
        this.pointerStart = null;
        if (Math.abs(distance) < 42) return;
        this.show(this.index + (distance < 0 ? 1 : -1), true);
      }, { passive: true });
      this.loadSlide(this.index);
      this.queueNextSlide();
      this.start();
    }

    disconnectedCallback() {
      this.stop();
      clearTimeout(this.preloadTimer);
    }

    loadSlide(index) {
      const slide = this.slides[index];
      const picture = slide?.querySelector('[data-airy-picture]');
      if (!picture || picture.dataset.airyLoaded === 'true') return;

      picture.querySelectorAll('source[data-srcset]').forEach((source) => {
        source.srcset = source.dataset.srcset;
        source.removeAttribute('data-srcset');
      });
      const image = picture.querySelector('[data-airy-image]');
      if (image) {
        if (image.dataset.srcset) image.srcset = image.dataset.srcset;
        if (image.dataset.src) image.src = image.dataset.src;
        image.removeAttribute('data-srcset');
        image.removeAttribute('data-src');
      }
      picture.dataset.airyLoaded = 'true';
    }

    queueNextSlide() {
      clearTimeout(this.preloadTimer);
      if (this.slides.length < 2) return;
      this.preloadTimer = setTimeout(() => {
        this.loadSlide((this.index + 1) % this.slides.length);
      }, 2200);
    }

    show(next, restart = false) {
      if (!this.slides.length) return;
      this.index = (next + this.slides.length) % this.slides.length;
      this.loadSlide(this.index);
      this.slides.forEach((slide, index) => {
        const active = index === this.index;
        slide.classList.toggle('is-active', active);
        slide.toggleAttribute('inert', !active);
        slide.setAttribute('aria-hidden', String(!active));
      });
      this.dots.forEach((dot, index) => {
        dot.classList.toggle('is-active', index === this.index);
        dot.setAttribute('aria-current', index === this.index ? 'true' : 'false');
      });
      this.queueNextSlide();
      if (restart) { this.stop(); this.start(); }
    }

    start() {
      if (!this.autoplay || this.slides.length < 2 || this.timer) return;
      this.timer = setInterval(() => this.show(this.index + 1), this.delay);
    }

    stop() {
      clearInterval(this.timer);
      this.timer = null;
    }
  }
  customElements.define('clan-airy-hero', ClanAiryHero);
}
